import { Navigate, useLocation } from 'react-router-dom'
// import { LoadingFallback } from './ui/loading-fallback'
import { useIsLoggedIn } from '@ekonavi/base-test';

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
	const location = useLocation();

	const isLoggedIn = useIsLoggedIn();
	// if (loading) {
	//   return <LoadingFallback className="h-screen" />
	// }

	if (!isLoggedIn) {
		// Redirect to login page with return url
		return (
			<Navigate
				to='/auth'
				state={{ from: location }}
				replace
			/>
		);
	}

	return <>{children}</>;
}